// src/components/ChargingStation/CreateAccountSection.tsx
import React from "react";
import CreateAccountForm from "../../pages/CreateAccountForm";

interface CreateAccountSectionProps {
  formEmail: string;
  handleCreateAccount: () => void;
  setNewOrder?: (newOrder: any) => void;
  orderId?: string;
}

const CreateAccountSection: React.FC<CreateAccountSectionProps> = ({
  formEmail,
  handleCreateAccount,
  setNewOrder,
  orderId,
}) => {
  return (
    <CreateAccountForm 
      formEmail={formEmail} 
      handleCreateAccount={handleCreateAccount}
      setNewOrder={setNewOrder}
      orderId={orderId}
    />
  );
};

export default CreateAccountSection;
